import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByPromocodeQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByPromocodeQueryType,
  AnalyticsSalesByPromocodeQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByPromocodeQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByPromocodeQueryType,
    AnalyticsSalesByPromocodeQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByPromocodeQueryType,
    AnalyticsSalesByPromocodeQueryVariablesType
  >(AnalyticsSalesByPromocodeQuery, options);
};
